import {
    PortfolioActorProfile,
    PortfolioCentralRateGroup,
    PortfolioCentralRateGroupOverview,
    PortfolioCentralRateGroupResult,
    PortfolioEnterpriseGroup,
    PortfolioRateGroupOverview,
    RateGroupWithPaymentPolicies,
} from '@mews-commander/data-access';

export enum RATE_GROUPS_TABS {
    CENTRAL_RATE_GROUPS = 'centralRateGroups',
    LOCAL_RATE_GROUPS = 'localRateGroups',
}

export type RateGroupOverview = PortfolioCentralRateGroupOverview | PortfolioRateGroupOverview;

export type RateGroup = RateGroupWithPaymentPolicies | PortfolioCentralRateGroup;

export interface WithProfiles {
    creatorProfile?: PortfolioActorProfile;
    updaterProfile?: PortfolioActorProfile;
}

type PortfolioCentralRateGroupWithProfiles = PortfolioCentralRateGroup &
    Pick<PortfolioCentralRateGroupResult, 'propertiesWithRateCounts' | 'propertyGroups'> &
    WithProfiles;

type LocalRateGroupWithProfiles = RateGroupWithPaymentPolicies & WithProfiles;

export type RateGroupWithProfiles = PortfolioCentralRateGroupWithProfiles | LocalRateGroupWithProfiles;

export type RateGroupTabValues = 'details' | 'policies' | 'rates' | 'properties';

export interface EnterpriseGroupWithRatesCount extends PortfolioEnterpriseGroup {
    ratesCount?: number;
}
